'use client';

import { c as _c } from "react/compiler-runtime";
import { useState } from 'react';
import { KPISection } from '@/features/analytics-negociacoes/components/KPISection';
import { AnaliseTemporal } from '@/features/analytics-negociacoes/components/AnaliseTemporal';
import { FunilConversaoCard } from '@/features/analytics-negociacoes/components/FunilConversaoCard';
import { PainelLateralCasos } from '@/features/analytics-negociacoes/components/PainelLateralCasos';
import type { PainelCasosSource } from '@/features/analytics-negociacoes/types/analytics.types';
import type { GeneralDashboard } from '@/features/negociacoes';
export const VisaoGeralTab = t0 => {
  const $ = _c(18);
  const {
    generalDashboardData
  } = t0;
  const [painelSource, setPainelSource] = useState(null);
  let t1;
  if ($[0] !== generalDashboardData.block1) {
    t1 = <KPISection data={generalDashboardData.block1} />;
    $[0] = generalDashboardData.block1;
    $[1] = t1;
  } else {
    t1 = $[1];
  }
  let t2;
  if ($[2] !== generalDashboardData.funnel) {
    t2 = generalDashboardData.funnel ?? [];
    $[2] = generalDashboardData.funnel;
    $[3] = t2;
  } else {
    t2 = $[3];
  }
  let t3;
  if ($[4] !== t2) {
    t3 = <FunilConversaoCard data={t2} onStageClick={setPainelSource} />;
    $[4] = t2;
    $[5] = t3;
  } else {
    t3 = $[5];
  }
  let t4;
  if ($[6] !== generalDashboardData.block2) {
    t4 = <AnaliseTemporal data={generalDashboardData.block2} />;
    $[6] = generalDashboardData.block2;
    $[7] = t4;
  } else {
    t4 = $[7];
  }
  let t5;
  if ($[8] !== t3 || $[9] !== t4) {
    t5 = <div className="grid grid-cols-1 items-stretch gap-5 lg:grid-cols-2">{t3}{t4}</div>;
    $[8] = t3;
    $[9] = t4;
    $[10] = t5;
  } else {
    t5 = $[10];
  }
  let t6;
  if ($[11] === Symbol.for("react.memo_cache_sentinel")) {
    t6 = () => setPainelSource(null);
    $[11] = t6;
  } else {
    t6 = $[11];
  }
  let t7;
  if ($[12] !== painelSource) {
    t7 = <PainelLateralCasos source={painelSource} onClose={t6} />;
    $[12] = painelSource;
    $[13] = t7;
  } else {
    t7 = $[13];
  }
  let t8;
  if ($[14] !== t1 || $[15] !== t5 || $[16] !== t7) {
    t8 = <>{t1}{t5}{t7}</>;
    $[14] = t1;
    $[15] = t5;
    $[16] = t7;
    $[17] = t8;
  } else {
    t8 = $[17];
  }
  return t8;
};